export default "__VITE_PUBLIC_ASSET__081c9878__"